jQuery(function($) {
  $('.faq-question').on('click', function() {
    const $item = $(this).parent('.faq-item');
    
    // Close all others
    $('.faq-item').not($item).removeClass('active');
    
    // Toggle the clicked one
    $item.toggleClass('active');
  });
});
